import {Settings, SettingsPreferences} from "./typing";
import {ComponentType} from "react";

type Preferences = Pick<Settings, "name" | "domain" | "email" | "presets">;

const SETTINGS_KEY = '__SETTINGS__.__PREFERENCES__';
let settings: SettingsPreferences = (globalThis as any)[SETTINGS_KEY] ?? undefined;

function parseComponent(component: ComponentType | string | undefined | null): ComponentType {
    if (typeof component === 'string') {
        return () => component;
    }
    return component ?? (() => null);
}

export function setPreferences(params: Preferences) {
    if (settings) {
        console.warn('Preferences are already set');
    }
    
    settings = (globalThis as any)[SETTINGS_KEY] = {
        siteName: params.name,
        domainName: params.domain,
        contactEmail: params.email,
        defaults: {
            AddressInfo: parseComponent(params.presets.footerAddress),
            ContactUsDesc: parseComponent(params.presets.sectionContactText)
        }
    };
}

export const preferences = (): SettingsPreferences => {
    if (!settings) {
        throw new Error('Preferences are not set');
    }
    return settings;
}